export function generateUniqueId() {
  return Math.round(Date.now() / 1000);
}
